export const functionNotImplYet = (contextName: string) => (functionName: string) => () => {
  console.error(`${functionName}: ${contextName} does not exist yet!`);
};
